import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ds-message-icon-info",
  "use": "icon-ds-message-icon-info-usage",
  "viewBox": "64 64 896 896",
  "content": "<symbol class=\"\" fill=\"currentColor\" aria-hidden=\"true\" viewBox=\"64 64 896 896\" id=\"icon-ds-message-icon-info\"><path d=\"M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol